const widget = {
  widgetNode: null,

  init() {
    this.widgetNode = document.querySelector('.js-widget');

    if(this.widgetNode) {
      this.widgetNode.addEventListener('click', (e) => e.target.parentNode.classList.toggle('is-open'), false);
    }
  },
};

export default widget;



// WEBPACK FOOTER //
// ./scripts/modules/widget.js